import { render } from "./nous_contacter.vue?vue&type=template&id=4bc883a6"
import script from "./nous_contacter.vue?vue&type=script&lang=js"
export * from "./nous_contacter.vue?vue&type=script&lang=js"

import "./nous_contacter.vue?vue&type=style&index=0&id=4bc883a6&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__